import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Image from '../Image';

import styles from './styles.module.scss';

const Intro = ({ stages, setStage, setRecommendation }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(null);

  const recommendations = [{
    key: 'solutions',
    name: 'tool_ui.opening_screen.q1_r1'
  }, {
    key: 'devices',
    name: 'tool_ui.opening_screen.q1_r2'
  }, {
    key: 'both',
    name: 'tool_ui.opening_screen.q1_r3'
  }];

  const getStarted = (recommendation) => {
    const stage = stages['devices' === recommendation ? 1 : 0];
    stage.curStep = 1;

    setStage(stage);
    setRecommendation(recommendation);

    // Adobe tracking
    if (window.globalLmd) {
      window.lmd = window.globalLmd;
      window.lmd.custom = t('tool_ui.opening_screen.start_experience');
      window._satellite.track('CustomInteraction');
    }

    window.scrollTo(0, 0);
  };

  const setSelectedRecommendation = (recommendation) => {
    setSelected(recommendation.key);

    // Adobe tracking
    if (window.globalLmd) {
      window.lmd = window.globalLmd;
      window.lmd.custom = t(recommendation.name);
      window._satellite.track('CustomInteraction');
    }
  };

  return <section className={styles.intro}>
    <div className={styles.intro_container}>
      <h2 className={styles.intro_heading}>
        {t('tool_ui.opening_screen.title')}
      </h2>
      <p className={styles.intro_text}>
        {t('tool_ui.opening_screen.subtitle')}
      </p>
      <h2 className={styles.intro_subheading}>
        {t('tool_ui.opening_screen.q1')}
      </h2>
      <div className={styles.recommendations}>
        {recommendations.map((recommendation, index) =>
          <div key={index} onClick={() => setSelectedRecommendation(recommendation)} className={styles.recommendation + (selected === recommendation.key ? ' ' + styles.selected : '')}>
            <Image src={'images_iax/recommendations/' + recommendation.key} height={140} />
            <div className={styles.text}>
              <div>{t(recommendation.name)}</div>
            </div>
            <Image src={'images_iax/icon-cross' + (selected === recommendation.key ? '-tick' : '')} width={40} height={40} type={'svg'} className={styles.icon} />
          </div>
        )}
      </div>
      <div className={styles.buttons}>
        <button onClick={() => getStarted(selected)} disabled={null === selected}>
          {t('tool_ui.opening_screen.start_experience')}
        </button>
      </div>
    </div>
  </section>;
}

export default Intro;
